import React from 'react'
import LiveOnlineFeesRight from './LiveOnlineFeesRight';

const CrashCourseFee = () => {
  return (
   <>
<div className='batch-schedule'>
    <div className='left-mode'>
  <p className='mentoring-mode-content'>
    Designed for learners on a tight schedule, this accelerated training delivers essential concepts 
    quickly and efficiently. Get intensive training with focused sessions that prepare you for your 
    career goals faster.
    </p>
    </div>
   <div className='separator'></div>
   <LiveOnlineFeesRight enrollText='Enroll Now' modeType="crash"/>
   </div>
   </>
  )
}

export default CrashCourseFee
